<template>
  <section id="welcome" class="overflow-hidden">
    <v-row no-gutters>
      <v-col class="hidden-sm-and-down" md="6">
        <v-img :src="require('@/assets/verf-groen.jpeg')" height="100vh" />
      </v-col>

      <v-col
        class="align-content-space-between layout wrap"
        cols="12"
        md="6"
        :pa-5="$vuetify.breakpoint.smAndDown"
      >

        <v-row align="start" justify="center">
          <v-col cols="11" md="11">
            <br />
            <br />
            <base-heading>Vergoedingen en Kosten</base-heading>
            <base-text>
              De vergoeding van de Generalistische Basis Geestelijke
              Gezondheidszorg (GBGGZ) is ondergebracht in de basisverzekering
              van de zorgverzekeringswet. Het valt wel onder het verplichte
              eigen risico van € 385 (2026) Als je dat nog niet gebruikt hebt
              voor andere medische kosten, dan trekt de verzekering dit af van
              de vergoeding voor de zorg die je bij mij ontvangt. Ik heb voor
              2026 met de meeste verzekeraars een contract afgesloten.
              Uitzonderingen zijn CZ, ONVZ en ENO. Check altijd zelf bij je verzekering of bij
              mij of de behandeling vergoed wordt.

              <h4>Afspraak wijzigen of annuleren</h4>

              Wil je zo snel mogelijk, of in ieder geval vóór 24 uur van te
              voren, een afspraak wijzigen of afzeggen wanneer dit nodig is. De
              zorgverzekaar vergoedt geen “no show”, vandaar dat de kosten voor
              jezelf zijn als je niet tijdig annuleert.
            </base-text>
              <v-simple-table>

      <thead>
        <tr>
          <th class="text-left">
            Diagnostiek
          </th>
          <th class="text-left">
            Code
          </th>
          <th class="text-left">
            Tarief
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>vanaf 45 minuten</td>
          <td>CO0432</td>
          <td>€ 167,16</td>
        </tr>
        <tr>
          <td>vanaf 60 minuten</td>
          <td>CO0562</td>
          <td>€ 192,00</td>
        </tr>
      </tbody>


      <thead>
        <tr>
          <th class="text-left">
            Behandeling
          </th>
          <th class="text-left">
            Code
          </th>
          <th class="text-left">
            Tarief
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>vanaf 45 minuten</td>
          <td>CO0497</td>
          <td>€ 142,24</td>
        </tr>
        <tr>
          <td>vanaf 60 minuten</td>
          <td>CO0627</td>
          <td>€ 169,00</td>
        </tr>
        <tr>
          <td>'no show'</td>
          <td>-</td>
          <td>€ 70,00</td>
        </tr>
      </tbody>


          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </section>
</template>


<script>
export default {
  name: "Aanmelden",
  data: () => ({
    //
  }),
};
</script>